// Deliberately distinct from legacy's 'Platform UI' so activity entries written
// by this app are distinguishable from the ones written by the legacy UI.
export const ACTIVITY_LOG_PLATFORM = 'Platform (new) UI';
export const ACTIVITY_LOG_ORIGIN = 'UI';
